import { inject, Injectable, OnDestroy } from "@angular/core";
import { LengthConverterPipe } from "@shared/pipes/lengthconverter.pipe";
import * as L from "leaflet";
import { ILatLng } from "polydraw";
import { Subject } from "rxjs";
import { MapUtil } from "src/util/map/map.util";
import { MarketSalesDataService } from "../estate/market-sales-data.service";
import { MapActionsService } from "./map-actions.service";

@Injectable()
export class DistanceLineService implements OnDestroy {
    private readonly mapActionsService = inject(MapActionsService);
    private readonly marketSalesService = inject(MarketSalesDataService);

    distanceLine: any;
    distanceLineLayer: any;
    distanceLabelLayer: any;

    ngUnsubscribe = new Subject();

    ngOnDestroy(): void {
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
    }

    showDistanceLine(latLng: ILatLng) {
        this.removeDistanceLine();

        const markerLatLng = [latLng.lat, latLng.lng];


        this.distanceLineLayer = L.layerGroup();
        this.distanceLabelLayer = L.layerGroup();
        this.mapActionsService.map.addLayer(this.distanceLineLayer);
        this.mapActionsService.map.addLayer(this.distanceLabelLayer);


        const distance: number = this.calculateDistance(latLng);
        if (distance > 0) {
            const latLang: ILatLng = {
                lat: Number(this.marketSalesService.targetEstateSale.latitude),
                lng: Number(
                    this.marketSalesService.targetEstateSale.longitude)
            };

            this.distanceLine = L.polyline(([]) as any, { color: "white", opacity: 1 }).addTo(this.distanceLineLayer);
            this.distanceLine.addLatLng(markerLatLng);
            this.distanceLine.addLatLng(latLang);
            const distanceMarker = L.divIcon({
                className: "distanceMarker",
                html: LengthConverterPipe.transform(distance, false, false, false, true)
            });

            L.marker(markerLatLng as any, { icon: distanceMarker }).addTo(this.distanceLabelLayer);
        }
    }

    private calculateDistance(latLng: ILatLng) {
        if (this.marketSalesService.targetEstateSale != null) {

            const markerLatLng = { lat: latLng.lat, lng: latLng.lng };

            const distance = MapUtil.calculateDistance(markerLatLng.lat,
                markerLatLng.lng,
                this.marketSalesService.targetEstateSale.latitude,
                this.marketSalesService.targetEstateSale.longitude);

            return Math.round(distance);
        }
        return 0;
    }

    removeDistanceLine() {
        if (this.distanceLineLayer) {
            this.mapActionsService.map.removeLayer(this.distanceLineLayer);
        }
        if (this.distanceLabelLayer) {
            this.mapActionsService.map.removeLayer(this.distanceLabelLayer);
        }
    }

}